import React, { useState } from 'react';
import { TextInput, View, Text } from 'react-native';
import { ActivityIndicator, Button, CustomKeyboardAvoidingView, Hr, InfoBox } from 'LocalGluons';
import { func, bool } from 'prop-types';
import { t } from 'Locale';
import theme from 'Theme';
import { useStore } from 'Store/Store';
import { Device } from 'DeviceUtils';

import defaultStyles, { buttonStyle } from './PageStyles.jss';

const NewUsername = ({ onSaved, onCancel, displayHeader }) => {
    const { appManager, userData, setUserData } = useStore();

    const [username, setUsername] = useState('');
    const [errorMessage, setErrorMessage] = useState(null);
    const [loading, setLoading] = useState(false);

    const saveUsername = async () => {
        if (!username || username.length === 0) {
            setErrorMessage(t('COMMON.USERNAME_FILLED'));
            return;
        }
        setLoading(true);
        try {
            await appManager.api.setProfile({
                nickname: username
            });
            const userInfo = await appManager.refreshToken();
            // Extend user data with new nickname
            setUserData({ ...userData, ...userInfo });
            onSaved();
        } catch (error) {
            console.log(error);
            setErrorMessage(error.localizedMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <CustomKeyboardAvoidingView>
            <View style={defaultStyles.container}>
                <View style={defaultStyles.innerConteiner}>
                    {displayHeader && (
                        <>
                            <Text style={defaultStyles.title}>{t('COMMON.CHANGE_USERNAME')}</Text>
                            <Hr />
                        </>
                    )}
                    <View style={defaultStyles.inputAndButtonConteiner}>
                        <Text
                            style={[defaultStyles.description, { marginBottom: 10 }]}
                            numberOfLines={10}
                        >
                            {t('COMMON.CHANGE_USERNAME_INFO_TXT')}
                        </Text>
                        <Text style={[defaultStyles.description, { marginBottom: 30 }]}>
                            {`${t('COMMON.CHANGE_USERNAME_DEFAULT_INFO')} ${userData?.login}`}
                        </Text>
                        {errorMessage && (
                            <InfoBox
                                style={[defaultStyles.infoBox, { marginTop: 0, marginBottom: 15 }]}
                                message={errorMessage}
                            />
                        )}
                        <View style={defaultStyles.textinputConteiner}>
                            <TextInput
                                style={[defaultStyles.input, { marginBottom: 35 }]}
                                placeholder={t('SETTINGS.NEW_USERNAME')}
                                placeholderTextColor={theme.placeholderTextColor}
                                onChangeText={setUsername}
                                value={username}
                                autoCapitalize="none"
                                returnKeyType="done"
                                onSubmitEditing={saveUsername}
                                testID="new_username_input"
                            />
                        </View>
                        <View style={defaultStyles.buttonWidth}>
                            <Button
                                style={buttonStyle}
                                title={t('SETTINGS.SAVE_USERNAME')}
                                onPress={saveUsername}
                                testID="save_username_button"
                            />
                            {Device.isTabletOrWeb ? null : (
                                <Button
                                    style={buttonStyle}
                                    title={t('COMMON.CANCEL')}
                                    onPress={onCancel}
                                    isSecondary
                                    testID="cancel_button"
                                />
                            )}
                        </View>
                    </View>
                </View>
                {loading && <ActivityIndicator isOverlay />}
            </View>
        </CustomKeyboardAvoidingView>
    );
};

NewUsername.defaultProps = {
    displayHeader: true
};

NewUsername.propTypes = {
    onSaved: func.isRequired,
    onCancel: func,
    displayHeader: bool
};

export default NewUsername;
